import { ChangeDetectionStrategy, Component, Input, isDevMode, OnChanges, OnInit } from '@angular/core';

import { BUS_AIRCRAFT_CODE } from '@fcom/common-booking/interfaces';
import { SentryLogger } from '@fcom/core/services';

import { Airport } from '../interface';

/**
 * @Unstable
 * Warning! This component is in active development and is not production ready.
 *
 * Documentation can be found in `storybook/stories/flights/timeline.stories.mdx`
 */
@Component({
  selector: 'fcom-timeline',
  templateUrl: './timeline.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineComponent implements OnChanges, OnInit {
  /**
   * Object containing the information for the Departure airport, including
   * - city name
   * - airport name
   * - airport code
   * - formatted dateTime of departure @example "08:45 Thu"
   *
   * Required
   */
  @Input() departure: Airport;

  /**
   * Object containing the information for the Arrival airport, including
   * - city name
   * - airport name
   * - airport code
   * - formatted dateTime of arrival @example "08:45 Thu"
   *
   * Required
   */
  @Input() arrival: Airport;

  @Input() isByBusOnly = false;

  departureIcon: string;
  arrivalIcon: string;

  constructor(private logger: SentryLogger) {}

  ngOnInit(): void {
    this.departureIcon = this.isByBusOnly ? BUS_AIRCRAFT_CODE.toLowerCase() : 'departure';
    this.arrivalIcon = this.isByBusOnly ? BUS_AIRCRAFT_CODE.toLowerCase() : 'arrival';
  }

  ngOnChanges(): void {
    if (isDevMode() && (!this.departure || !this.arrival)) {
      this.logger.warn('Departure and Arrival information are mandatory');
    }
  }
}
